import { useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const BenefitsBlockVB = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = window && window.innerWidth < 768;

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <div
      id="beneficios"
      className="w-screen py-[140px] lg:py-[130px] bg-white flex justify-center items-center gap-[120px] flex-wrap"
    >
      <div className="w-full max-w-[85rem] flex flex-col lg:flex-row justify-center items-start gap-10 lg:gap-[7.5rem] pb-[80px] lg:pb-0">
        {/* Esquerda */}
        <div className="flex-[2] md:max-w-[23.563rem] h-full flex flex-col justify-between items-center md:items-start gap-8 px-6 w-full">
          <div className="p-2.5 flex-col justify-start items-center md:items-start gap-2.5 flex">
            <div className="text-[#696969] font-normal leading-[17px] hidden md:block">
              Benefícios
            </div>
            <div className="self-stretch text-black text-3xl text-center md:text-left font-light leading-10 lg:pt-4">
              Economize na sua conta de luz com energia sustentável
            </div>
          </div>
        </div>

        {/* Imagem Central */}
        <div className="flex-[2] md:max-w-[23.563rem] h-full justify-center items-center w-full hidden lg:flex">
          {activeIndex === 0 && (
            <img
              src="/tim/images/beneficios/v2/reduza-seus-custos.webp"
              alt="Sem custos"
              className="w-full h-auto"
              width={377}
              height={377}
              loading="lazy"
            />
          )}
          {activeIndex === 1 && (
            <img
              src="/tim/images/beneficios/v2/energia-limpa.webp"
              alt="Energia limpa"
              className="w-full h-auto"
              width={377}
              height={377}
              loading="lazy"
            />
          )}
          {activeIndex === 2 && (
            <img
              src="/tim/images/beneficios/v2/parceria-com-a-thopen.webp"
              alt="Parceria com a Thopen"
              className="w-full h-auto"
              width={377}
              height={377}
              loading="lazy"
            />
          )}
        </div>

        {/* Direita */}
        <div className="flex-[3] flex flex-col w-full">
          {!isMobile ? (
            <div className="hidden md:block">
              {/* Benefício 1 */}
              <div className="w-full">
                <div
                  className="flex items-center gap-4 py-4 cursor-pointer hover:opacity-60 transition-opacity duration-200"
                  onClick={() => setActiveIndex(0)}
                >
                  <span className="flex w-[48px] h-[48px]">
                    <img
                      src="/tim/images/icones/ico-circulo-dolar.webp"
                      alt="Sem custos"
                      className="w-full h-full object-contain"
                      width={48}
                      height={48}
                      loading="lazy"
                    />
                  </span>
                  <h3 className="text-black text-xl font-bold">Sem custos</h3>
                </div>
                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    activeIndex === 0 ? "max-h-[200px]" : "max-h-0"
                  }`}
                >
                  <p className="text-secondary-text text-left font-normal leading-normal px-4 pt-0 pb-4">
                    De investimento, instalação ou taxas e sem fidelidade
                  </p>
                </div>
              </div>

              {/* Benefício 2 */}
              <div className="w-full">
                <div
                  className="flex items-center gap-4 py-4 cursor-pointer hover:opacity-60 transition-opacity duration-200"
                  onClick={() => setActiveIndex(1)}
                >
                  <span className="flex w-[48px] h-[48px]">
                    <img
                      src="/tim/images/icones/ico-circulo-globo.webp"
                      alt="Energia limpa"
                      className="w-full h-full object-contain"
                      width={48}
                      height={48}
                      loading="lazy"
                    />
                  </span>
                  <h3 className="text-black text-xl font-bold">
                    Energia limpa
                  </h3>
                </div>
                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    activeIndex === 1 ? "max-h-[200px]" : "max-h-0"
                  }`}
                >
                  <p className="text-secondary-text text-left font-normal leading-normal px-4 pt-0 pb-4">
                    Uso de energia renovável (solar, biogás e hídrica) mais
                    barata e ainda contribui para o meio ambiente
                  </p>
                </div>
              </div>

              {/* Benefício 3 */}
              <div className="w-full">
                <div
                  className="flex items-center gap-4 py-4 cursor-pointer hover:opacity-60 transition-opacity duration-200"
                  onClick={() => setActiveIndex(2)}
                >
                  <span className="flex w-[48px] h-[48px]">
                    <img
                      src="/tim/images/icones/ico-circulo-chat.webp"
                      alt="Parceria com a Thopen"
                      className="w-full h-full object-contain"
                      width={48}
                      height={48}
                      loading="lazy"
                    />
                  </span>
                  <h3 className="text-black text-xl font-bold">
                    Parceria com a Thopen
                  </h3>
                </div>
                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    activeIndex === 2 ? "max-h-[200px]" : "max-h-0"
                  }`}
                >
                  <p className="text-secondary-text text-left font-normal leading-normal px-4 pt-0 pb-4">
                    Maior plataforma de energia limpa do Brasil
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="md:hidden">
              <Swiper
                modules={[Navigation]}
                spaceBetween={10}
                slidesPerView={1.5}
                centeredSlides={true}
                navigation={false}
                onSlideChange={handleSlideChange}
                className="swiper-container"
              >
                {/* Slide 1 */}
                <SwiperSlide className="flex-shrink-0 w-full h-auto relative px-2">
                  <img
                    src="/tim/images/beneficios/v2/reduza-seus-custos.webp"
                    alt="Sem custos"
                    className="mx-auto object-cover"
                    width={"80%"}
                    height={"auto"}
                    loading="lazy"
                  />
                  <div className="text-center mt-4">
                    <h3 className="text-black text-lg font-bold">Sem custos</h3>
                    <p className="text-secondary-text text-sm font-normal mt-2">
                      De investimento, instalação ou taxas e sem fidelidade
                    </p>
                  </div>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide className="flex-shrink-0 w-full h-auto relative px-2">
                  <img
                    src="/tim/images/beneficios/v2/energia-limpa.webp"
                    alt="Energia limpa"
                    className="mx-auto object-cover"
                    width={"80%"}
                    height={"auto"}
                    loading="lazy"
                  />
                  <div className="text-center mt-4">
                    <h3 className="text-black text-lg font-bold">
                      Energia limpa
                    </h3>
                    <p className="text-secondary-text text-sm font-normal mt-2">
                      Uso de energia renovável (solar, biogás e hídrica) mais
                      barata e ainda contribui para o meio ambiente
                    </p>
                  </div>
                </SwiperSlide>

                {/* Slide 3 */}
                <SwiperSlide className="flex-shrink-0 w-full h-auto relative px-2">
                  <img
                    src="/tim/images/beneficios/v2/parceria-com-a-thopen.webp"
                    alt="Parceria com a Thopen"
                    className="mx-auto object-cover"
                    width={"80%"}
                    height={"auto"}
                    loading="lazy"
                  />
                  <div className="text-center mt-4">
                    <h3 className="text-black text-lg font-bold">
                      Parceria com a Thopen
                    </h3>
                    <p className="text-secondary-text text-sm font-normal mt-2">
                      Maior plataforma de energia limpa do Brasil
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BenefitsBlockVB;
